import { render, staticRenderFns } from "./TechnicalReportList.vue?vue&type=template&id=781fdfab"
import script from "./TechnicalReportList.vue?vue&type=script&lang=js"
export * from "./TechnicalReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports